export enum RefCodeType {
}

export enum CountryType {
  Usa = 'USA',
  Us = 'US' // ISO country code
}

export enum RefCodeName {
  Hrs = 'HRS'
}